import { strings } from '@/shared/strings';
import styles from './CaseInstructions.module.css';

export interface CaseInstructionsProps {
  /** The instructions on the case. Empty when there are none. */
  text: string;
  /**
   * A band inside the card rather than a card of its own. On the job view it
   * sits between the head and the notes, where a bordered box inside a bordered
   * box read as two things.
   */
  flush?: boolean;
}

/**
 * The instructions, at the top of the case, in full. Section 9 of the request
 * of 20 September 2026 put them there; the request of 24 September 2026 took
 * the toggles away; section 5 of the request of 5 October 2026 made the two
 * fields one.
 *
 * One headed block and nothing to press. A case that had both a doctor's and a
 * lab's text shows both, because the merge kept each under its own heading
 * inside the one text, and the text is drawn as typed.
 *
 * With nothing in it the block is ABSENT, not empty: a heading over nothing
 * would push the case down the screen to say that there is nothing to say.
 */
export function CaseInstructions({
  // Defaulted although the type says string: the production client returns
  // responses unvalidated, so a field the API has not shipped yet arrives as
  // undefined. The incident of 23 September 2026, when a `.trim()` on one took
  // the job screen down. Absent reads as empty, which is no block.
  text = '',
  flush = false,
}: CaseInstructionsProps) {
  if (text.trim() === '') return null;

  return (
    <section
      className={`${styles.instructions} ${flush ? styles.flush : ''}`}
      aria-label={strings.instructions.region}
    >
      <div>
        <h4 className={styles.h}>{strings.instructions.title}</h4>
        <p className={styles.text}>{text}</p>
      </div>
    </section>
  );
}
